import { BaseError, type BaseErrorParameters } from './base';

export class SandboxMaximumThresholdReachedError extends BaseError {
  constructor({ cause }: Pick<BaseErrorParameters, 'cause'>) {
    super({
      cause,
      code: 'sandbox_maximum_threshold_reached_error',
      docsUrl:
        'https://www.dynamic.xyz/docs/developer-dashboard/sandbox-vs-live#sandbox-vs-live',
      name: 'SandboxMaximumThresholdReachedError',
      shortMessage:
        'Your sandbox environment has reached the maximum MAU. Please use a live environment for production traffic.',
    });
  }
}
